import React, { useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Switch, Route, Redirect } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Asct from './asct';
import Security from './security';
import Safety from './safety';
import Versement from './versement';
import Nec from './nec';
import Avitaillement from './avitaillement';
import AETGVPACA from './aetgv-paca';
import PRMAssistance from './prm-assistance';
import Emargement from './emargement';
import BulletinComposition from './Bulletin-composition';
import Restauration from './restauration';
import { Header, Sidebar, Copyright, BreadCrumb, BackButton } from '../../components';
import { useBlockNavigation, useRoutes } from '../../hooks';
import { paths } from '../../routes';

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.default,
    display: 'flex',
    minHeight: '100vh',
  },
  toolbar: theme.mixins.toolbar,
  container: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflowX: 'hidden',
  },
  content: {
    minHeight: 300,
    background: theme.palette.background.paper,
    margin: `${theme.spacing(3)}px 0`,
    padding: theme.spacing(1),
  },
  infos: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  title: {
    color: theme.palette.text.primary,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  back: {
    marginLeft: -theme.spacing(2),
    marginRigth: theme.spacing(1),
  },
}));

export const Main: React.FC = () => {
  useBlockNavigation({ isLoggedIn: false, navigateTo: paths.login.path });
  const classes = useStyles();
  const [mobileOpened, setMobileOpen] = useState(false);
  const { currentPath } = useRoutes();

  const handleMobileSidebarToggle = useCallback(() => {
    setMobileOpen((opened) => !opened);
  }, [setMobileOpen]);

  return (
    <div className={classes.root}>
      <Header onMenuClick={handleMobileSidebarToggle}></Header>
      <Sidebar mobileOpened={mobileOpened} onClose={handleMobileSidebarToggle} />
      <main className={classes.container}>
        <div className={classes.toolbar} />
        <div className={classes.infos}>
          <div className={classes.left}>
            <BackButton className={classes.back} />
            <Typography variant="h5" className={classes.title}>
              {currentPath?.label || 'Détail'}
            </Typography>
          </div>
          <BreadCrumb />
        </div>
        <div className={classes.content}>
          <Switch>
            <Route path={paths.asct.path}>
              <Asct />
            </Route>
            <Route path={paths.security.path}>
              <Security />
            </Route>
            <Route path={paths.safety.path}>
              <Safety />
            </Route>
            <Route path={paths.versement.path}>
              <Versement />
            </Route>
            <Route path={paths.proprete.path}>
              <Nec />
            </Route>
            <Route path={paths.avitaillement.path}>
              <Avitaillement />
            </Route>
            <Route path={paths.aetgv.path}>
              <AETGVPACA />
            </Route>
            <Route path={paths.prmAssistance.path}>
              <PRMAssistance />
            </Route>
            <Route path={paths.emargement.path}>
              <Emargement />
            </Route>
            <Route path={paths.bulletincomposition.path}>
              <BulletinComposition />
            </Route>
            <Route path={paths.restauration.path}>
              <Restauration />
            </Route>
            <Route path="/" exact>
              <Redirect to={paths.asct.path} />
            </Route>
          </Switch>
        </div>
        <Copyright />
      </main>
    </div>
  );
};

export default Main;
